import { Controller } from "@hotwired/stimulus"
import { showToast } from "../helpers/toast"

export default class extends Controller {
  static targets = ["count"]

  connect() {
    this.subscription = null
    this.setupCable()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  setupCable() {
    if (typeof window.App === "undefined" || typeof window.App.cable === "undefined") return

    this.subscription = window.App.cable.subscriptions.create("NotificationsChannel", {
      received: (data) => {
        this.updateCount(data.unread_count)
        this.showNotificationToast(data)
      }
    })
  }

  updateCount(count) {
    if (!this.hasCountTarget) return

    if (count > 0) {
      this.countTarget.textContent = count
      this.countTarget.classList.remove("hidden")
    } else {
      this.countTarget.classList.add("hidden")
    }
  }

  showNotificationToast(data) {
    if (!data.title) return

    const toastType = data.type === "error" ? "error" : "info"
    const label = data.message ? `${data.title} — ${data.message}` : data.title
    showToast(label, toastType)

    if (["lead_gen", "qualification"].includes(data.type)) {
      document.dispatchEvent(new CustomEvent("ia-action:completed", { detail: data }))
    }
  }
}
